var app = angular.module('leonardo');

var WPFormSelect = function() {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    transclude: true,
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      options: '=',
      label: '@',
      empty: '@',
      optionsRegexp: '@',
      parent: '=',
      multiple: '=',
      ngChange: '&',
      ngDisabled: '='
    },
    templateUrl: 'views/templates/form/wp-form-select.html',
    link: function (scope, element, attrs, ctrls) {
      scope.name = attrs.name;
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];

      scope.$watch('value', function (new_value) {
        if(scope.parent){
          var value = scope.$parent.ngModelCtrl.$modelValue;
          value[scope.name] = new_value;
          scope.$parent.ngModelCtrl.$setViewValue(value);
        }
        scope.ngModelCtrl.$setViewValue(new_value);
      });

      scope.ngModelCtrl.$render = function () {
        scope.value = scope.ngModelCtrl.$viewValue;
      };
    }
  };
};

app.directive('wpFormSelect', [WPFormSelect]);
